import React from 'react';

import { getBankLogo } from '../../utils/getBankLogo';
import { getBalanceDisplay } from '../../utils/usCurrencyFormatter';

const PaymentDetailOption = ({ item, totalInvestment }) => {

    const isWallet = item?.sourceType === 'Wallet';
    const isInsufficientBalance = isWallet && totalInvestment > item?.availableBalance;

    return (
        <>
            {getBankLogo(item?.brandName)} {item?.brandName === 'DWOLLA' ? 'Realbricks Wallet' : item?.brandName || ''}{' '}
            {item?.sourceType !== 'Wallet' && item?.sourceType !== 'add new' && `*** ${item.lastFourDigit || ''}`}
            {isWallet && !isInsufficientBalance ? '$' : ''}
            <span>
                {isInsufficientBalance ? (
                    <span className='error-text'>Insufficient balance</span>
                ) : (
                    getBalanceDisplay(item.availableBalance)
                )}
            </span>
        </>
    )
};

export default PaymentDetailOption